import React, { useEffect, useState } from 'react';
interface Props {
  className?: string;
  onComplete?: () => void;
}
export function SeedToSproutMorph({
  className = '',
  onComplete
}: Props) {
  const [started, setStarted] = useState(false);
  useEffect(() => {
    // Start morph immediately
    setStarted(true);
    // Notify parent when animation is done (stem 1.0s + leaves 0.6s + buffer)
    const t1 = setTimeout(() => onComplete?.(), 1900);
    return () => {
      clearTimeout(t1);
    };
  }, []);
  return <div className={`relative ${className}`} data-id="element-118">
      <svg width="150" height="180" viewBox="0 0 150 180" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-119">
        {/* Base/Ground — always visible */}
        <ellipse cx="75" cy="160" rx="45" ry="15" fill="rgba(197,216,45,0.1)" data-id="element-120" />

        {/* === STEM (draws upward) === */}
        <path d="M73 160 C 73 120, 65 90, 75 70" stroke="#5D4037" strokeWidth="6" strokeLinecap="round" fill="none" className={started ? 'morph-stem-grow' : 'morph-stem-hidden'} data-id="element-121" />

        {/* === LEFT LEAF === */}
        <path d="M70 100 C 40 90, 30 110, 35 125 C 50 120, 65 115, 70 100 Z" fill="#A8BF24" className={started ? 'morph-leaf-left' : 'morph-leaf-hidden'} data-id="element-122" />

        {/* === RIGHT LEAF === */}
        <path d="M74 85 C 100 70, 115 85, 110 105 C 95 105, 80 95, 74 85 Z" fill="#C5D82D" className={started ? 'morph-leaf-right' : 'morph-leaf-hidden'} data-id="element-123" />
      </svg>

      <style dangerouslySetInnerHTML={{
      __html: `
        /* STEM — hidden until it grows */
        .morph-stem-hidden {
          stroke-dasharray: 120;
          stroke-dashoffset: 120;
        }

        /* STEM — starts immediately */
        .morph-stem-grow {
          stroke-dasharray: 120;
          stroke-dashoffset: 120;
          animation: morphStemGrow 1.0s ease-out forwards;
        }

        @keyframes morphStemGrow {
          0% { stroke-dashoffset: 120; }
          100% { stroke-dashoffset: 0; }
        }

        /* LEAVES — hidden initially */
        .morph-leaf-hidden {
          opacity: 0;
          transform: scale(0);
        }

        /* LEFT LEAF — grows after stem is mostly done (0.7s) */
        .morph-leaf-left {
          transform-origin: 70px 100px;
          opacity: 0;
          transform: scale(0) rotate(10deg);
          animation: morphLeafGrow 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.7s forwards;
        }

        /* RIGHT LEAF — slightly after left (1.0s) */
        .morph-leaf-right {
          transform-origin: 74px 85px;
          opacity: 0;
          transform: scale(0) rotate(-10deg);
          animation: morphLeafGrow 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 1.0s forwards;
        }

        @keyframes morphLeafGrow {
          0% {
            opacity: 0;
            transform: scale(0) rotate(10deg);
          }
          50% {
            opacity: 1;
            transform: scale(1.1) rotate(-2deg);
          }
          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }
      `
    }} data-id="element-124" />
    </div>;
}